export function isPhoneValidHr(phone?: string | null): boolean {
  if (!phone) return false;

  let clean = phone.replace(/\D/g, '');

  // +385 / 00385
  if (clean.startsWith('385')) {
    clean = '0' + clean.substring(3);
  }

  // mora imati 9 ili 10 znamenki
  if (clean.length < 9 || clean.length > 10) return false;

  // poznati fiksni prefiksi
  const landlinePrefixes = [
    '01',
    '020', '021', '022', '023',
    '031', '032', '033', '034', '035',
    '040',
    '042', '043', '044',
    '047', '048', '049',
    '051', '052', '053',
    '060', '072'
  ];

  return landlinePrefixes.some(prefix =>
    clean.startsWith(prefix)
  );
}

export function formatPhoneHr(value: string): string {
  if (!value) return '';

  let digits = value.replace(/\D/g, '');

  // +385 / 00385
  if (digits.startsWith('385')) {
    digits = '0' + digits.substring(3);
  }

  // max 10 znamenki
  digits = digits.substring(0, 10);

  // Zagreb (01)
  if (digits.startsWith('01')) {
    if (digits.length <= 2) return digits;
    if (digits.length <= 5)
      return `${digits.substring(0, 2)} ${digits.substring(2)}`;
    return `${digits.substring(0, 2)} ${digits.substring(2, 5)} ${digits.substring(5)}`;
  }

  // ostali gradovi (0xx)
  if (digits.length <= 3) return digits;
  if (digits.length <= 6)
    return `${digits.substring(0, 3)} ${digits.substring(3)}`;

  return `${digits.substring(0, 3)} ${digits.substring(3, 6)} ${digits.substring(6)}`;
}